
/**
 * トラック運転手マスタページ
 * トラック運転手情報の登録・編集・管理
 */

import React from 'react'
import { useTruckDrivers } from '@/features/masters/hooks/useTruckDrivers'
import TruckDriversTable from '@/features/masters/components/TruckDriversTable'
import AddTruckDriverButton from '@/features/masters/components/AddTruckDriverButton'
import { Skeleton } from "@/shared/ui/skeleton"
import { PageLayout } from '@/shared/components'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/shared/ui/breadcrumb'
import { Link } from 'react-router-dom'

/**
 * トラック運転手マスタページコンポーネント
 */
export default function TruckDriversPage() {
    const { data: drivers, isLoading, error, createEntity, updateEntity, deleteEntity } = useTruckDrivers()

    const addDriver = async (data: import('@/features/masters/types').TruckDriverInsert) => {
        const result = await createEntity(data)
        return !!result
    }

    const updateTruckDriver = async (id: string, data: import('@/features/masters/types').TruckDriverUpdate) => {
        const result = await updateEntity(id, data)
        return !!result
    }

    const deleteTruckDriver = async (id: string) => {
        return await deleteEntity(id)
    }

    const checkDriverInUse = async (_id: string) => {
        return false
    }

    if (isLoading) {
        return (
            <PageLayout
                title="トラック運転手マスタ"
                description="トラック運転手情報の登録・編集を行います。"
                actions={<Skeleton className="h-10 w-28" />}
            >
                <Breadcrumb className="mb-6">
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/">ホーム</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/masters">マスタ管理</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbPage>トラック運転手マスタ</BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
                <Skeleton className="h-[300px] w-full" />
            </PageLayout>
        )
    }

    if (error) {
        return (
            <PageLayout
                title="トラック運転手マスタ"
                description="トラック運転手情報の登録・編集を行います。"
            >
                <Breadcrumb className="mb-6">
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/">ホーム</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/masters">マスタ管理</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbPage>トラック運転手マスタ</BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
                <div className="text-red-600">
                    <p>データの読み込み中にエラーが発生しました: {String(error)}</p>
                </div>
            </PageLayout>
        )
    }

    return (
        <PageLayout
            title="トラック運転手マスタ"
            description="トラック運転手情報の登録・編集を行います。"
            actions={<AddTruckDriverButton onAdd={addDriver} />}
        >
            <Breadcrumb className="mb-6">
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/">ホーム</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/masters">マスタ管理</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>トラック運転手マスタ</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
            <TruckDriversTable
                data={drivers || []}
                isLoading={isLoading}
                onEdit={updateTruckDriver}
                onDelete={deleteTruckDriver}
                checkDriverInUse={checkDriverInUse}
            />
        </PageLayout>
    )
} 